import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Trans } from '@lingui/react';
import { Popover, Tooltip, Avatar } from '@tecsinapse/cortex-react';
import 'react';
import { Link } from 'react-router-dom';

const AccountSettings = ({
  logout,
  currentUser,
  linkPortal,
  showMyAccount,
  customOptionsUser
}) => {
  const {
    nome,
    avatarLink
  } = currentUser;
  const pathSection = "/minha-conta";
  const hasCustomOptionsUser = (customOptionsUser ?? []).length > 0;
  return /* @__PURE__ */ jsxs(Popover.Root, { trigger: "click", children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: "Minha conta", children: /* @__PURE__ */ jsx(Avatar, { name: nome, src: avatarLink, className: "mb-micro" }) }) }),
    /* @__PURE__ */ jsx(Popover.Content, { children: /* @__PURE__ */ jsxs("div", { className: "flex bg-white flex-col", children: [
      /* @__PURE__ */ jsxs("div", { className: "px-deca py-mili flex items-center gap-x-mili border-b border", children: [
        /* @__PURE__ */ jsx(Avatar, { name: nome, src: avatarLink }),
        /* @__PURE__ */ jsx("p", { className: "text-sub", children: nome })
      ] }),
      showMyAccount ? /* @__PURE__ */ jsx("div", { className: "flex items-center gap-x-mili hover:bg-secondary-light hover:cursor-pointer px-deca py-mili", children: /* @__PURE__ */ jsx("a", { href: `${linkPortal}${pathSection}`, className: "no-underline text-sub text-black", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "nwikRk"
      } }) }) }) : /* @__PURE__ */ jsx(Fragment, {}),
      hasCustomOptionsUser ? (customOptionsUser ?? []).map((option) => /* @__PURE__ */ jsx("div", { className: "flex items-center hover:bg-secondary-light hover:cursor-pointer px-deca py-mili text-sub text-black", children: /* @__PURE__ */ jsx(Link, { className: "no-underline text-sub text-black", to: option.path, children: /* @__PURE__ */ jsx("p", { children: option.label }) }) }, option.path)) : /* @__PURE__ */ jsx(Fragment, {}),
      /* @__PURE__ */ jsx("div", { onKeyDown: logout, onClick: logout, className: "flex items-center hover:bg-secondary-light hover:cursor-pointer px-deca py-mili text-sub text-black", children: /* @__PURE__ */ jsx(Trans, { .../*i18n*/
      {
        id: "8cDgMo"
      } }) })
    ] }) })
  ] });
};

export { AccountSettings };
